<div class="card">
  <div class="card-header" (click)="toggleAccordion($event)">
    {{ title }}
  </div>
  <div class="card-body" [class.open]="isOpen" *ngIf="isOpen">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</div>